import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {SurveyService} from "./survey.service";
import {LoggerService} from "../common/logger.service";
import {ISurveyResult} from "./survey-model";
import {Constants} from "../constants";
import {uxCartRouterCommands} from "../util/locale-util";
import {MarkupService} from "../common/markup.service";
import {Util} from "../util/util";
import {TranslateService} from "../translation/translate.service";
import * as _ from 'lodash';
import {IRestResponse} from "../common/rest-response.model";
import {BaseComponent} from "../base.component";
import {UserService} from "../common/user.service";
import {IShareLinkOptions} from "../social/social-models";

@Component({
    selector: 'survey-results',
    templateUrl: './survey-results.component.html',
    styleUrls: ['./survey.component.scss'],
    standalone: false
})
export class SurveyResultsComponent extends BaseComponent implements OnInit {

    result: ISurveyResult;
    busy: boolean = false;
    shareOptions: IShareLinkOptions;
    isProductAdded: boolean = false;
    titleText: string;

    constructor(
        private userService: UserService,
        loggerService: LoggerService,
        private surveyService: SurveyService,
        private markupService: MarkupService,
        private router: Router,
        private route: ActivatedRoute,
        private translateService: TranslateService,
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.shareOptions = {shareType: Constants.SHARE_TYPE_MARKETING_PAGE, shareId: Constants.SHARE_NAME_SURVEY, shareFrom: Constants.SURVEY_RESULTS_ROUTE};
        const surveyId: string = this.route.snapshot.queryParamMap.get("surveyId");
        if (surveyId) {
            this.getSurveyResults(surveyId);
        } else {
            this.router.navigate(uxCartRouterCommands(Constants.LANDING_STATE));
        }
        this.markupService.setTitleFromTranslationTag("cart.survey.page.title");
    }

    getSurveyResults(surveyId: string) {
        this.busy = true;
        this.surveyService.getSurveyResults(surveyId).subscribe((response: IRestResponse) => {
            this.log.debug(response);
            if (response.success) {
                this.result = response.message;
                this.setTitle();
            }
            this.busy = false;
        }, (error: any) => {
            this.log.error("getSurveyResults", error);
            this.busy = false;
        });
    }

    setTitle() {
        if (!_.isEmpty(this.result.customerName)) {
            const replacementMap = new Map([['name', this.result.customerName]]);
            this.translateService.translateRequest({
                tag: 'cart.survey.intro.title.with.name',
                replacements: replacementMap
            }).then((data: string) => {
                this.titleText = data;
            });
        } else {
            this.translateService.translate("cart.survey.intro.title.for.you").then((data: any) => {
                this.titleText = data;
            });
        }
    }

    goToRetakeQuiz() {
        Util.redirectInternal(Constants.URL_SURVEY);
    }
}
